import { render, staticRenderFns } from "./RolesManager.vue?vue&type=template&id=0a49f9ad&scoped=true&"
import script from "./RolesManager.vue?vue&type=script&lang=ts&"
export * from "./RolesManager.vue?vue&type=script&lang=ts&"
import style0 from "./RolesManager.vue?vue&type=style&index=0&id=0a49f9ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a49f9ad",
  null
  
)

export default component.exports